export default {"container":"PrI81","promoCodeItem":"m0WU3","promoCodeItemText":"z6FAb","selected":"_5zkKJ","bookieLogo":"kVr83"};